export default "__VITE_ASSET__BI$PpY7I__"